/**
 * Error code returned from server
 */
export enum ErrorCode {
  GroupUserNotBelong = '0x018001',
  GroupUserServiceTypeDeleted = '0x018002',
  GroupUserDepartmentDeleted = '0x018003',
  GroupUserNoCreateSideDocumentPermission = '0x018004',
  GroupUserServiceTypeAndDataPermissionNotMatch = '0x018005',
  GroupUserServiceTypeNotPermission = '0x018006',
  GroupUserDataPermissionNotPermission = '0x018007',
  GroupUserDataPermissionNotFound = '0x018008',
  GroupUserNotPermission = '0x018009',
  ContractExist = '0x018010',
  NotPermissionOnDocumentType = '0x044105',
  NotPermissionOnBranch = '0x044106',
  NotPermissionOnUser = '0x044107',
  ExportGroupCustomerNotFound = '0x100473',
  ExportGroupCustomerNotPermission = '0x100474',
  ExportCustomerNotPermission = '0x100475',
  ExportCustomerNotFound = '0x100476',
  BranchNotPermission = '0x005212',
  UnAuthorized = '0x00102',
  Permission = '0x00103',
  VersionDuplicate = '0x00122',
  CertificateCodeDuplicate = '0x00118',
  TaxCodeDuplicate = '0x00117',
  nameDuplicate = '0x00125',
  PasswordInvalid = '0x00126',
  DocumentsDuplicate = '0x001703',
  MissingRequiredContractFields = '0x2000000',
  ServiceTypeHasContract = '0x001507',
  DuplicateServiceName = '0x001508',
  NoAccessToContracts = '0x002200',
  NoAuthenToAccess = '0x102009',
    ContractProcessed = '0x001720',
  NotPermissionWithContract = '0x001709',
  AnonymousUnAuthorized = '0x002100',
  FormatImportExcel = '0x002017',
  EmptyImportExcel = '0x002018',
  OutOfMoneyOtp = '0x002013',
  OutOfMoneyOtpNew = '0x002128',
  DuplicateServiceCode = '0x002219',
  ContactSystemAdmin = '0x00116',
  NotPermissionForm = '0x001726',
  CopyNotPermission = '0x002302',
  HashKeyNotExist = '0x002400',
  HashKeyExpired = '0x002401',
  ResetPasswordSuccess = '0x00710',
  accountLock = '0x00109',
  AccountVerify = '0x00115',
  AccountNotVerify = '0x002403',
  AccountVerifyFailed = '0x002404',
  ErrorImageRecognition = '0x002413',
  ContactTemplateHasContract = '0x001601',
  ContactTemplateHasContractAndTemplate = '0x001602',
  DocumentTemplateCodeExist = '0x002503',
  FileContentIsDenied = '0x002504',
  DocumentInactive = '0x001505',
  DocumentNotExist = '0x001501',
  CannotDecode = '0x00115',
  NotPermissionTemplate = '0x001510',
  RequestError = '0x1672003',
  WrongInfor = '0x1672004',
  WarningOutOfContractQuantity = '0x002015',
  ConfigTemplate = '0x002505',
  MasterDataBlock = '0x002506',
  MasterDataNotfound = '0x002509',
  MasterDataDocumentTemplateBlock = '0x002507',
  MasterDataTypeDocumentTemplateBlock = '0x002508',
  DataNotfound = '0x002006',
  FieldIsDeleted = '0x002513',
  CategoryIsDeleted = '0x002510',
  RefCategoryIsDeleted = '0x002511',
  MasterDataTypeDuplicateName = '0x002514',
  MasterDataTypeNotFound = '0x002515',
  MergeFieldAlreadyExist = '0x002517',
  MergeFieldError = '0x002518',
  FormatImportCustomerExcel = '0x002017',
  EmptyImportCustomerExcel = '0x002018',
  FormatImportExcelError = '0x002519',
  EmptyFileImportExcelError = '0x002520',
  TemplateNotForLot = '0x002522',
  CheckCertOCSPLostConnection = '0x001903',
  CheckCertExpriredError = '0x001811',
  SignHashFileError = '0x002005',
  IsHasSignProcess = '0x002007',
  CertificateWrongError = '0x002009',
  CertificateNoCA = '0x001906',
  OCSPNoSupport = '0x001905',
  ValidateCTSNumber = '0x002224',
  ValidateName = '0x002225',
  ProcedureNameExisted = '0x002701',
  OtpNotSupport = '0x002008',
  DepartmentCodeExist = '0x005601',
  DepartmentNameExist = '0x005602',
  BothDepartmentCodeAndNameExist = '0x005604',
  DepartmentDeletedOrLocked = '0x005605',
  DepartmentLockError = '0x005606',
  DepartmentUnlockError = '0x005607',
  UpdateUserErrorRepresentativeExist = '0x005608',
  AssignRepresentativeNotFound = '0x005609',
  AssignRepresentativeInactive = '0x005610',
  AddUserDepartmentInactive = '0x005611',
  AssignRepresentativeAlready = '0x005612',
  CodeCPMatched = '0x002803',
  UserMatchedEnterprise = '0x002823',
  CPIsDeletedOrBlock = '0x002802',
  isContractProcess = '0x002107',
  CPCanNotDelete = '0x002824',
  CPCanNotUpdate = '0x002825',
  NotPermissionChangeDefaultCert = '0x002208',
  CreateUpdateDigitalContract1 = '0x0015',
  CreateUpdateDigitalContract2 = '0x001509',
  CreateUpdateDigitalContract3 = '0x00801',
  CreateUpdateDigitalContract4 = '0x003015',
  CreateUpdateDigitalContract5 = '0x003014',
  CreateUpdateDigitalContract6 = '0x003012',
  CreateUpdateDigitalContract7 = '0x003011',
  CreateUpdateDigitalContract8 = '0x003013',
  CreateUpdateDigitalContract9 = '0x003018',
  CreateUpdateDigitalContract10 = '0x003019',
  CreateUpdateDigitalContract11 = '0x003020',
  CreateUpdateDigitalContract12 = '0x003021',
  InBackupTime = '0x003024',
  ActiveContract = '0x003016',
  ActiveContract1 = '0x003017',
  ActiveContract2 = '0x00104',
  ParentContractCanNotDelete = '0x002011',
  NotFoundDataReport = '0x44102',
  ErrorGetData = '0x002215',
  UserInactive = '0x003022',
  ContractSuccess = '0x003023',
  DuplicateProcess = '0x004201',
  LotNotFound = '0x004202',
  ContractLotTransferSignFail = '0x004203',
  ProcessHasBeenFinish = '0x004204',
  ProcessHasBeenCancel = '0x004205',
  NotEnoughMoneyEnterprise = '0x002844',
  ExistType = '0x005200',
  NoExistValue = '0x005201',
  SignTransactionRetryCECAFalse = '0x005202',
  SignTransactionRetryMOITFalse = '0x005203',
  SignTransactionDuplicate = '0x005204',
  FalseToReTry = '0x005205',
  DataNotExist = '0x044102',
  Property1 = '0x005300',
  Property2 = '0x005301',
  NotEnoughMoneyTimestamp = '0x002846',
  RealmInactive = '0x005206',
  ContractNotExist = '0x004102',
  ContractHasBeenDeleted = '0x028301',
  ContractHasBeenDeleted2 = '0x028302',
  DocumentGroup = '0x00605',
  SignUserNotManageCertificate = '0x006000',
  OtpNotFound = '0x001815',
  OtpNotFoundSubjectConfirm = '0x001815',
  OtpExpiredError = '0x001816',
  RetryExpiredMOIT = '0x005208',
  SignTransactionFailedToResetDown = '0x005209',
  ContractNotExistToSave = '0x004209',
  TemplateNotActiveOrDeleted = '0x001511',
  TransactionResetFailed = '0x005207',
  SignUsbTokenFail = '0x002031',
  CloudCa = '0x002809',
  MaxLengthCa = '0x002804',
  DuplicateCa = '0x002805',
  ErrorCa = '0x00106',
  DuplicateSystemCode = '0x002806',
  UploadFileSms = '0x002108',
  GroupCustomerRemoved = '0x017001',
  GroupCustomerExisted = '0x017002',
  GroupCustomerDeleted = '0x017003',
  CustomerNotExisted = '0x017004',
  ErrorInUpdateCustomer = '0x017009',
  ErrorInUpdateCustomer1 = '0x017011',
  ErrorInUpdateCustomer2 = '0x0170012',
  ErrorInUpdateCustomer3 = '0x0170013',
  ErrorInUpdateCustomer4 = '0x0170014',
  ErrorInUpdateCustomer5 = '0x0170015',
  ErrorInUpdateCustomerAdd = '0x0170016',
  ErrorInUpdateCustomerRemove = '0x0170017',
  CustomerIdentityOtpOutOfMoney = '0x100033',
  CheckMaxApprover = '0x002523',
  MaxSizeError = '0x00802',
  ContractExpireTime= '0x002206',
  SessionExpired= '0x00111',
  PasswordExpired= '0x00129',
  CheckCertOcspNoSupport = '0x001904',
  SignButNotConnectOcsp = '0x001907',
  VerifyEnterprise= '0x002414',
  isNotAutoContract= '0x002309',
  ExistSignature= '0x002111',
  NotChangeContractCode= '0x002230',
  RefusedIdentify= '0x100032',
  BusinessesRunOutOfMoneySMS = '0x100034',
  Identify= '0x100035',
  SsoLoginCode= '0x001S01',
  SmsWarningClient = '0x010092',
  SmsWarningUser = '0x010093',
  GetTokenFromSSO = '0x001S02',
  GetDataFromSSO = '0x002255',
  CerficicateNoError = '0x00233',
  UserDisableAdmin = '0x00705',
  UserNotFound = '0x00708',
  SendLinkContract= '0x100478',
  DeleteDepartmentNormal = '0x018011',
  DeleteDepartmentDigital = '0x018012',
  DeleteUserNormal = '0x018013',
  DeleteUserDigital = '0x018014',
  GroupUserDataNormal = '0x018015',
  GroupUserDataDigital = '0x018016',
  GroupUserDataNotFoundNormal = '0x018017',
  GroupUserDataNotFoundDigital = '0x018018',
  HasApproval = "0x100501",
  HasRejectApproval = "0x100502",
  HaveNotPermission = "0x100500",
  ForwardSignFailed = "0x100504",
  FirstTimePassSamePassword = '0x002436',
  CloudCAConnectFail = '0x002821',
  OtpNotFoundSubjectConfirmKycSContract = '0x001837',
  Account_Subscribe_File_Download_Capacity_resource = '0x002032',
  Account_No_Subscribe_File_Download_Capacity_resource = '0x002033',
  GenDataCustomerFromFile = '0x014001',
  GenDataImageBase64NotEmty = '0x014002',
  GenDataListTypeDocumentNotEmty = '0x014003',
  GenDataTypeCustomerInvalid = '0x014004',
  CancelSignFlowWithContract = '0x001735',
  BlockUserConfigNotification = '0x339351',
  RESET_OTP_CUSTOMER_NOT_IN_SIGN_FLOW = '0x020152',
  OTP_EXCEED_SENDING_LIMIT = '0x020153',
  IP_ALLOWED_IP_EXPORT = '0x020240',
  NOT_IP_CONFIG = '0x020201',
  IP_ALLOWED_IP_IMPORT_OVER = '0x020241',
  CLOUD_CA_USER_NOT_EXIST = '59009',
  CLOUD_CA_REQUEST_NOT_EXIST = '58007',
  CLOUD_CA_TRANSACTION_NOT_EXIST = '58011',
  CLOUD_CA_REQUEST_TIMEOUT = '58061',
  CLOUD_CA_USER_UNAUTHORISED = '58062',
  CLOUD_CA_USER_NOT_SUFFICIENT = '4005',
  CLOUD_CA_USER_NOT_ACCEPTED = '4006',
  CLOUD_CA_USER_INVALID = '59117',
  CLOUD_CA_INTERNAL_SERVER_ERROR_CERT = '50000',
  IP_ALLOWED_REGEX_IP_INVALID = '0x020202',
  IP_ALLOWED_IP_DUPPLICATE = '0x020203',
  TWO_FACTOR_AUTHEN_TIME_OUT = '0x020204',
  TWO_FACTOR_CERTIFICATE_INVALID = '0x020205',
  CERTIFICATE_USER_NO_MAXLENGTH = '0x020206',
  CERTIFICATE_USER_ID_INVALID = '0x020176',
  TOKEN_AUTHEN_TWO = '0x00135',
  CLOUD_CA_USER_CERTIFICATE_NOT_EXIST = '59034',
  CLOUD_CA_INTERNAL = '59002',
  CLOUD_CA_INTERNAL_EX = '58001',
  CLOUD_CA_INTERNAL_EX1 = '58002',
  CLOUD_CA_DEVICE_EXPIRE = '59071',
  CLOUD_CA_INTERNAL_EX2 = '59075',
  CLOUD_CA_INTERNAL_EX3 = '59001',
  CLOUD_CA_ORTHER_EX = '4008',
  CLOUD_CA_EXPIRED = '0x020180',
  CLOUD_CA_NOT_FOUND = '0x002810',
  CLOUD_CA_CONTACT_ADMIN = '59033',
  GROUP_CUSTOMER_DOES_NOT_EXIST = '0x359191',
  RECORDS_COUNT_EXCEEDED = '0x004266',
  GOOGLE_LOGIN_TOKEN_INVALID = '0x020300',
  GOOGLE_LOGIN_EMAIL_EXIST = '0x020301',
  GOOGLE_LOGIN_ACCOUNT_HAS_LINKED = '0x020302',
  GOOGLE_LOGIN_USER_INVALID = '0x020303',
  GOOGLE_LOGIN_REFERENCE_INVALID = '0x020304',
  GOOGLE_LOGIN_APP_PARAM_INVALID = '0x020305',
  DUPLICATE_CERTIFICATENO = '0x100425',
  DOCUMENT_ERROR = '0x002110',
  DUPLICATE_CUSTOMER = '0x100425',
  EXPIRED_CONTRACT_1MB = '0x016011',
  QUICKLY_CONTRACT_PERMISSION = '0x100426',
  NOT_CREATE_LOT_DOCUMENT = '0x0022260',
  PIN_REQUIRED = '0x369300',
  SERIAL_REQUIRED = '0x369301',
  OUT_OF_RESOURCES_10MB= '0x016012',
  SOCIAL_LOGIN_TOKEN_INVALID = "0x020318",
  SOCIAL_LOGIN_EMAIL_EXIST = "0x020319",
  SOCIAL_LOGIN_ACCOUNT_HAS_LINKED = "0x020320",
  SOCIAL_LOGIN_USER_INVALID = "0x020321",
  SOCIAL_LOGIN_REFERENCE_INVALID = "0x020322",
  SIGN_MULTI_NOT_FOUND_CONTRACT_DIGITAL_VALID = '0x006022',
  SIGN_DIGITAL_MULTI_USB_TOKEN_NUMBER_FILE_INVLAID = '0x006101',
  SIGN_DIGITAL_MULTI_CLOUD_CA_NUMBER_FILE_INVLAID = '0x006101',
  FILE_PDF_ERRROR = "0x001704",
  ERROR_USERNAME = "0x3010251",
  ERROR_EMAIL = "0x3010252",
  ERROR_VERIFY_CODE = "0x3010253",
  EXPIRED_VERIFY_CODE = "0x3010254",
  RESOURCE_QUANTITY_CHANGED = "0x020332",
  RESOURCE_EXPIRED = "0x020330",
  ENTERPRISE_NOT_EXIST = "0x020331",
  EMAIL_VALID = "0x001203",
  ERROR_SYSTEM = "0x00016",
  NOT_HAVE_MULTILPE_USER = "0x400000",
  ACCOUNT_NOT_CF = "0x002403",
  ADMIN_FOR_ASSISTAN = "0x002000",
  AUTHEN_FAIL = "0x0200001",
  ONLY_SUPPORT_SCONTRACT = "0x020101",
  VNEID_EXCEPTION = '0x0022260',
  VNEID_VALIDATE_DESCRIPTION_EXCEPTION = '0x0022261',
  VNEID_VERIFY_EXCEPTION = '0x0022262',
  VNEID_VERIFY_BAD_REQUEST_EXCEPTION = '0x0022263',
}
